<template>

	<box :label="title">

		<template slot="meta-r">
			<span class="textlink" @click="zoomIn()" :class="{'disabled':false}">Zoom in</span>
			&nbsp;&nbsp; 
			<span class="textlink" @click="zoomOut()" :class="{'disabled':(field_width<=10)}">Zoom out</span>
			&nbsp;&nbsp; 
			<span class="textlink" @click="show_view_options=!show_view_options">Visning</span>
		</template>      
      
		<div class="timeline-container" :class="{'has-sidebar':show_sidebar, 'grid-highlight-weeks':true}">

			<div class="timeline-sidebar" v-if="show_sidebar" :style="{'width':sidebar_width+'px'}">
				<div class="timeline-row months">
					<div class="field month">Måned</div>
				</div>
				<div class="timeline-row daynames" v-if="show_dates">
					<div class="field dayname">Ugedag</div>
				</div>
				<div class="timeline-row daynumbers" v-if="show_dates">
					<div class="field daynumber">Dag</div>
				</div>
				<div class="timeline-row weeks" v-if="show_weeks">
					<div class="field week">Uge</div>
				</div>

				<template v-for="(entry,entry_i) in entries">
					<div class="timeline-row">
						<div class="field entry" @click="onEntrySidebarClick(entry)">
							{{entry.title}}
						</div>
					</div>
				</template>

			</div>

			<div class="timeline-content-container" :style="timeline_content_container_css">
				<div class="timeline-content" :style="timeline_content_css">				

					<div class="timeline-row months">
						<template v-for="(d,i) in timeline_months">
							<div class="field month" :style="month_field_css(d)">{{monthTitles[d.m]}} {{d.y}}</div>
						</template>
					</div>
					<div class="timeline-row daynames" v-if="show_dates">
						<template v-for="(d,i) in timeline_dates">
							<div class="field dayname" :class="field_classes(d)" :style="field_css">{{dayInitials[d.dn]}}</div>
						</template>
					</div>
					<div class="timeline-row daynumbers" v-if="show_dates">
						<template v-for="(d,i) in timeline_dates">
							<div class="field daynumber" :class="field_classes(d)" :style="field_css">{{d.d}}</div>
						</template>
					</div>
					<div class="timeline-row weeks" v-if="show_weeks">
						<template v-for="(d,i) in timeline_weeks">
							<div class="field week" :style="month_field_css(d)">Uge {{d.w}}</div>
						</template>
					</div>

					<template v-for="(entry,entry_i) in entries">
						<div class="timeline-row entry">
							<template v-for="(d,i) in timeline_dates">
								<div class="field entry jeff" :class="field_classes(d)" :style="field_css">

								</div>
							</template>

							<div class="timeline-entry" :class="entry_marker_classes(entry)" :style="entry_marker_css(entry)" @click="onEntryClick(entry)">
								<div class="title" v-if="entry.title" :style="entry_marker_title_css(entry)">{{entry.title}}</div>
								<div class="middle"></div>
								<div class="end end-r" :style="entry_marker_end_css('r',entry)"></div>
								<div class="end end-l" :style="entry_marker_end_css('l',entry)"></div>
								<div class="done-bar" v-if="entry.done_pct" :style="entry_marker_donebar_css(entry)"></div>
							</div>

						</div>
					</template>

				</div>
			</div>

		</div>



		<template v-if="show_view_options">    

			<div class="grid">
				<div class="col m10">
				<inputfield label="Vis Datoer">
					<div class="checkbox">
					<input type="checkbox" v-model="show_dates">
					</div>
				</inputfield>        
				</div>
				<div class="col m10">
				<inputfield label="Vis uger">
					<div class="checkbox">
					<input type="checkbox" v-model="show_weeks">
					</div>
				</inputfield>        
				</div>
				<div class="col m20">
				<inputfield label="Highlight uger">
					<div class="checkbox">
					<input type="checkbox" v-model="grid_highlight_weeks">
					</div>
				</inputfield>
				</div>
				<div class="col m20">
				<inputfield label="Vis sidebar">
					<div class="checkbox">
					<input type="checkbox" v-model="show_sidebar">
					</div>
				</inputfield>
				</div>
				<div class="col m10">
				<inputfield label="Sidebar bredde">
					<input type="number" min="20" max="600" step="10" v-model="sidebarWidth">
				</inputfield>
				</div>
				<div class="col m20">
				
				<select name="" id="" v-if="globals.show_beta_content">
					<option value="done_pct">BETA: Vis opgavers færdighed</option>
					<option value="time_spent_pct">BETA: Vis opgavers tidsforbrug</option>
					<option value="booked_pct">BETA: Vis opgavers tidsbooking</option>
				</select>
				
				</div>
			</div>

			<template v-if="globals.show_beta_content">

				<br><br>

				<div class="grid">
				<div class="col m50">
					<inputfield label="Beta: Days back">
					<input type="number" min="20" max="600" step="10" v-model="days_back">
					</inputfield>        
				</div>
				<div class="col m50">
					<inputfield label="Days ahead">
					<input type="number" min="20" max="600" step="10" v-model="days_ahead">
					</inputfield>
				</div>
				</div>

			</template>

		</template>
			

    </box>

</template>

<script>

import helpers from '../helpers.js';
import globals from '../globals.js';
import moment from 'moment'
import Box from '.././components/Box'

export default {
	//name: 'projects_timeline',
	components: { Box },

	props: [ 'title', 'entries', 'days-back', 'days-ahead', 'show-sidebar', 'sidebar-width' ],

	data: function () {
		return {

			globals: globals,

			grid_highlight_weeks: true,
			
			show_dates: false,
			show_weeks: true,

			expandedRows: [],
			days_back: 7,
			days_ahead: 180,
			dayInitials: ['','s','m','t','o','t','f','l','s'],
	        monthTitles: ['','januar','februar','marts','april','maj','juni','juli','august','september','oktober','november','december'],
			field_width: 15,

			show_view_options: false,
		}
	},

	computed: {

		show_sidebar(){
			if( this.$props.showSidebar == undefined ) return false
			if( this.$props.showSidebar == true ) return true
			return false
		},

		sidebar_width(){
			if( this.$props.sidebarWidth == undefined ) return 120
			return this.$props.sidebarWidth
		},
		

		now(){
			return moment()
		},

		timeline_dates(){
			var output = []
			var datespan = this.days_ahead + this.days_back + 1
			for( var i = 0; i < datespan; i++ ) {
				var offset = i - this.days_back
				var momente = moment().add(offset, 'days')
				var d = parseInt(momente.format('D'))
				var m = parseInt(momente.format('MM'))
				var y = parseInt(momente.format('YYYY'))
				var dn = parseInt(momente.format('d')) + 1
				var w = parseInt(momente.format('W'))
				var entry = { d:d, m:m, y:y, dn:dn, w:w }
				if( i == this.days_back ) entry.today = true
				output.push(entry)
			}
			return output
		},

		timeline_months(){
			var output = []
			for( var i = 0; i < this.timeline_dates.length; i++ ) {
				var date = this.timeline_dates[i]
				var lastOutputItem = output[output.length-1]
				if( lastOutputItem && lastOutputItem.m == date.m ) {
					output[output.length-1].days_count++
				} else {
					output.push({
						m: date.m,
						y: date.y,
						days_count: 1,
					})
				}
			}
			return output
		},

		timeline_weeks(){
			var output = []
			for( var i = 0; i < this.timeline_dates.length; i++ ) {
				var date = this.timeline_dates[i]
				var lastOutputItem = output[output.length-1]
				if( lastOutputItem && lastOutputItem.w == date.w ) {
					output[output.length-1].days_count++
				} else {
					output.push({
						w: date.w,
						days_count: 1,
					})
				}
			}
			return output
		},

		timeline_content_container_css(){
			var css = {}
			css.width = 'calc(100% - ' + this.sidebar_width + 'px)'
			if( !this.show_sidebar ) css.width = '100%'
			return css
		},
		
		timeline_content_css(){
	      return {
	        width: (this.days_ahead + 1 + this.days_back) * this.field_width + 'px',
	      }
		},	

		field_css(){
	      return {
	        width: this.field_width + 'px',
	      }
	    },


	}, // computed

	methods: {


		isRowExpanded(row_i){
			if( this.expandedRows[row_i] && this.expandedRows[row_i] == true ) return true
			return false
		},

		toggleRowExpanded(row_i,boolean){
			if( boolean === undefined ) boolean = !this.isRowExpanded(row_i)
			this.$set( this.expandedRows, row_i, boolean )
		},

		month_field_css(m) {
			return {
				width: this.field_width * m.days_count + 'px',
			}
		},

		field_classes(d){
			var cls = {}
			if( d.today ) cls.today = true
			cls[ 'day' + parseInt(d.dn) ] = true
			return cls	
		},

//------------------------------------------------------------------------------

	entry_marker_css(entry){
		
		var bgcolor = '#333'; if( entry.color ) bgcolor = entry.color
		var textcolor = 'white'

		var firstdate = moment().subtract(this.days_back, 'days')
		
		var start_days_diff = moment(entry.date_from,'YYYY-MM-DD').diff(firstdate, 'days')
		var end_days_diff = moment(entry.date_to,'YYYY-MM-DD').diff(firstdate, 'days')
		
		var l = start_days_diff + 1
		var w = end_days_diff - l + 1 + 1

		//if( l < 0 ) {
		//  w = w - l
		//  l = 0
		//}
		//var maxwidth = ( this.days_ahead + 1 + this.days_back ) - start_days_diff
		//if( w > maxwidth ) w = maxwidth

		return {
			left: l * this.field_width + 'px',
			width: w * this.field_width + 'px',
			'background-color': bgcolor,
			'color': textcolor,
		}
	},

	entry_marker_classes(entry){
		var c = {}
		c.l = true
		return c
	},
	
	entry_marker_title_css(entry){
		return {}
		if(!entry.color) return
		var bgColor = entry.color
		return {
			'background-color': bgColor
		}
	},
	
	entry_marker_end_css(side,entry){

	},

//------------------------------------------------------------------------------


		timeline_entry_marker_end(side,data){
			return {}
			var bgColor = data.color
			var css = {
				'border-color': bgColor+' transparent transparent transparent',
			}
			if( side == 'l' ) {
				css['border-width'] = '10px 10px 0 0'
				css['border-color'] = bgColor+' transparent transparent transparent'
			}
			if( side == 'r' ) {
				css['border-width'] = '0 10px 10px 0'
				css['border-color'] = 'transparent '+bgColor+' transparent transparent'
			}
			return css
		},

		triggerEntryPopup(project){
			globals.modal_timeline_project_popup.project = project
			globals.modal_timeline_project_popup.active = true
		},

		entry_marker_donebar_css(entry){
			var done_pct = entry.done_pct
			return { 'width': done_pct+'%' }
		},

		onZoomUpdateViewSettings(){
			var z = this.field_width
			this.grid_highlight_weeks = ( z < 30 )
			this.show_dates = ( z >= 30 )      
		},

		zoomIn(){
		  this.field_width += 5
		  this.onZoomUpdateViewSettings()
	    },

	    zoomOut(){
			if( this.field_width > 10 ) this.field_width -= 5
			this.onZoomUpdateViewSettings()
	    },

		updateDaysBack(){
			var value = this.$refs.daysBackInput.value
			this.days_back = value
		},

		updateDaysAhead(){
			var value = this.$refs.daysAheadInput.value
			this.days_ahead = value
		},


		onEntryClick(entry){
			this.$emit('entry-click', entry)
		},

		onEntrySidebarClick(entry){
			this.$emit('sidebar-entry-click', entry)
		},



	}, // methods

	created(){
		
		if( this.$props.daysBack != undefined ) this.days_back = parseInt(this.$props.daysBack)
		if( this.$props.daysAhead != undefined ) this.days_ahead = parseInt(this.$props.daysAhead)
			
		if( this.$props.showDates != undefined ) this.show_dates = this.$props.showDates
		if( this.$props.showWeeks != undefined ) this.show_weeks = this.$props.showWeeks

		this.onZoomUpdateViewSettings()

	},

	// created
	// mounted

}
</script>



// WEBPACK FOOTER //
// Timeline.vue?7ea90f70